"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Vehicle_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vehicle = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const orm_1 = require("../orm");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const Document_1 = require("./Document");
let Vehicle = Vehicle_1 = class Vehicle extends orm_1.CDBaseEntity {
    constructor() {
        super(...arguments);
        this._id = (0, uuid_1.v4)();
        this.createdAt = new Date();
        this.documents = [];
        this.photoIds = [];
    }
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Vehicle_1, legacy_enums_1.VehicleStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.VehicleStatus.Deleted:
                return {
                    deletedAt: defined,
                };
            case legacy_enums_1.VehicleStatus.Declined:
                return {
                    deletedAt: undefined,
                    declinedAt: defined,
                };
            case legacy_enums_1.VehicleStatus.Accepted:
                return {
                    deletedAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: defined,
                };
            case legacy_enums_1.VehicleStatus.Pending:
            default:
                return {
                    deletedAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                };
        }
    }
};
exports.Vehicle = Vehicle;
__decorate([
    (0, orm_1.CDObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Vehicle.prototype, "_id", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Vehicle.prototype, "licensePlate", void 0);
__decorate([
    (0, orm_1.CDCreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Vehicle.prototype, "createdAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Vehicle.prototype, "ownerUserId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Vehicle.prototype, "modelId", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Vehicle.prototype, "acceptedAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Vehicle.prototype, "declinedAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Vehicle.prototype, "deletedAt", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Vehicle.prototype, "declinationReason", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Vehicle.prototype, "color", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Vehicle.prototype, "manufactureYear", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Document_1.Document),
    __metadata("design:type", Array)
], Vehicle.prototype, "documents", void 0);
__decorate([
    (0, orm_1.CDColumn)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => value.sort((a, b) => (a > b ? 1 : b > a ? -1 : 0))),
    __metadata("design:type", Array)
], Vehicle.prototype, "photoIds", void 0);
exports.Vehicle = Vehicle = Vehicle_1 = __decorate([
    (0, orm_1.CDEntity)("vehicles")
], Vehicle);
//# sourceMappingURL=Vehicle.js.map